import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { SplitLinesPipe }          from './split-lines.pipe';
import { CaretPositionDirective }  from './caret-position.directive';
import { ParagraphMeterComponent } from './paragraph-meter.component';


@NgModule({
  declarations: [
    ParagraphMeterComponent,
    CaretPositionDirective,
    SplitLinesPipe,
  ],
  imports:      [
    CommonModule
  ],
  exports:      [
    ParagraphMeterComponent,
    CaretPositionDirective,
  ]
})
export class ParagraphMeterModule {}
